import script from "./GifItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./GifItem.vue?vue&type=script&setup=true&lang=ts"

import "./GifItem.vue?vue&type=style&index=0&id=fea2090a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fea2090a"]])

export default __exports__